// Canonical module registry — keys/routes MUST match backend auth.MODULE_REGISTRY.
export const MODULES = [
  { key: "overview", route: "/", label: "Overview" },
  { key: "assets", route: "/assets", label: "Asset Management" },
  { key: "control", route: "/control", label: "Control Assurance" },
  { key: "cloud", route: "/cloud", label: "Cloud Security" },
  { key: "identity", route: "/identity", label: "Identity Health" },
  { key: "soc", route: "/soc", label: "SOC Operations" },
  { key: "firewall", route: "/firewall", label: "Firewall Health" },
  { key: "webgw", route: "/webgw", label: "Web Gateway Health" },
  { key: "vuln", route: "/vuln", label: "Vulnerability Mgmt" },
  { key: "email", route: "/email", label: "Email Security" },
  { key: "aisec", route: "/aisec", label: "AI Security" },
  { key: "projects", route: "/projects", label: "Project Management" },
  { key: "support", route: "/support", label: "Support Effectiveness" },
];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  org_admin: "Org Admin",
  analyst: "Analyst",
  viewer: "Viewer",
};

// Modules a user may access. super_admin sees all; others use /auth/me `modules`.
export function allowedModules(user) {
  if (!user) return [];
  if (user.role === "super_admin") return MODULES.map((m) => m.key);
  return user.modules || [];
}

// First landing route a user is entitled to (used when redirected off a blocked route).
export function firstAllowedRoute(user) {
  const keys = allowedModules(user);
  const first = MODULES.find((m) => keys.includes(m.key));
  return first ? first.route : "/account/password";
}
